import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { getCampaignById } from "../../api/services/campaignService";
import { getCampaignUrl, createSlugFromTitle } from "../../utils/slugUtils";

/**
 * Component to handle backward compatibility for old story campaign ID-based URLs
 * Redirects /story/campaigns/:id to the new slug-based URL format
 */
const CampaignStoryIdRedirect = () => {
  const { id } = useParams();
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        setLoading(true);
        // Fetch campaign by ID
        const response = await getCampaignById(id);
        
        if (response && response.data) {
          const campaign = response.data;
          // Check if campaign has redirects data
          if (!campaign.redirects || !Array.isArray(campaign.redirects) || campaign.redirects.length === 0) {
            setError(true);
            return;
          }
          // Generate the correct URL based on redirects
          const url = getCampaignUrl(campaign);
          if (!url) {
            setError(true);
            return;
          }
          setRedirectUrl(url);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching campaign by ID:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchAndRedirect();
    }
  }, [id]);

  // Show loading state
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If error or no redirect URL, redirect to campaigns list
  if (error || !redirectUrl) {
    return <Navigate to="/campaigns" replace />;
  }

  // Redirect to the new slug-based URL
  return <Navigate to={redirectUrl} replace />;
};

export default CampaignStoryIdRedirect;

